/**
 * Better Auth browser client. Same origin as the app; the server mounts the
 * auth handler at /api/auth. `inferAdditionalFields` types our extra `role`.
 */

import type { Auth } from "@server/auth";
import { inferAdditionalFields } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  basePath: "/api/auth",
  plugins: [inferAdditionalFields<Auth>()],
});
